export default (props) => (
  /**
   * Grid horizontal fake utilizado para simular um grid horizontal de mapa.
   * Encontrado na configuração do output de impressão ao ativar 'Grid de Coordenadas'.
  */
  <svg
    width={641}
    height={12}
    viewBox="0 0 640 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">
      {"\n\t.st0{fill:none;stroke:#5E5E5E;stroke-width:0.5;}\n"}
    </style>
    <line className="st0" x1="640" y1="1.2" x2="0" y2="1.2"/>
    <line className="st0" x1="639.8" y1="9" x2="639.8" y2="1"/>
    <line className="st0" x1="548.4" y1="8.9" x2="548.4" y2="0.9"/>
    <line className="st0" x1="457.1" y1="8.9" x2="457.1" y2="0.9"/>
    <line className="st0" x1="365.7" y1="8.9" x2="365.7" y2="0.9"/>
    <line className="st0" x1="274.3" y1="8.9" x2="274.3" y2="0.9"/>
    <line className="st0" x1="182.9" y1="8.9" x2="182.9" y2="0.9"/>
    <line className="st0" x1="91.6" y1="8.9" x2="91.6" y2="0.9"/>
    <line className="st0" x1="0.2" y1="8.9" x2="0.2" y2="1"/>
  </svg>
);

